import {
  Button,
  Col,
  EditButton,
  Form,
  getDefaultSortOrder,
  Icons,
  Input,
  List,
  Row,
  Space,
  Table,
  TagField,
  TextField,
  UrlField,
  useTable,
} from "@pankod/refine-antd";
import {
  CrudFilters,
  IResourceComponentsProps,
  useTranslate,
} from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import useMediaScreen from "hooks/useMediaScreen";
import React from "react";
import { ISample, ISampleResponse } from "types/sample.interface";
import { getOrderNumber } from "utils";

export const SampleList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { isMobile } = useMediaScreen();

  const { tableProps, sorter, searchFormProps }: any = useTable<ISampleResponse>({
      resource: 'samples',
      initialPageSize: 100,
      onSearch: (params) => {
          const filters: CrudFilters = [];
          const input = params;
          filters.push({
              field: 'search',
              operator: 'in',
              value: input,
          });
          return filters;
      },
  });
  const current = tableProps?.pagination?.current;
  const pageSize = tableProps?.pagination?.pageSize;

  return (
      <List>
          <Row style={{ display: 'block' }}>
              <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                  <TextField value='Total:' style={{ color: '#626262', fontSize: '14px', fontWeight: 700 }} />
                  <TextField value={tableProps?.pagination?.total} style={{ color: '#626262', fontSize: '14px', fontWeight: 700 }} />
              </div>
              <Col>
                  <Form layout='vertical' {...searchFormProps}>
                      <Form.Item label='Search' name='search' style={{ width: isMobile ? "100%" : '50%' }} initialValue=''>
                          <Input placeholder='Track, Title, Artist, Source' prefix={<Icons.SearchOutlined />} />
                      </Form.Item>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Form.Item>
                              <Button htmlType='submit' type='primary'>
                                  Filter
                              </Button>
                          </Form.Item>
                          <ButtonExport path='samples' />
                      </div>
                  </Form>
              </Col>
              <Col>
                  <Table
                      {...tableProps}
                      pagination={{
                          ...tableProps?.pagination,
                          showSizeChanger: true,
                      }}
                      rowKey='id'
                  >
                      <Table.Column dataIndex='_id' key='_id' title='Index' render={(value, item, index) => <TextField value={getOrderNumber(current, pageSize, index)} />} />
                      <Table.Column
                          dataIndex='track'
                          key='track'
                          title='Track'
                          render={(value) => <TextField value={value} />}
                          defaultSortOrder={getDefaultSortOrder('track', sorter)}
                          sorter
                      />
                       <Table.Column
                          dataIndex='title'
                          key='title'
                          title='Title'
                          render={(value) => <TextField value={value} />}
                          defaultSortOrder={getDefaultSortOrder('title', sorter)}
                          sorter
                      />
                       <Table.Column
                          dataIndex='artist'
                          key='artist'
                          title='Artist'
                          render={(value) => <TextField value={value} />}
                          defaultSortOrder={getDefaultSortOrder('artist', sorter)}
                          sorter
                      />
                      <Table.Column
                          dataIndex='source'
                          key='source'
                          title='Source'
                          render={(value) => <TagField value={value} />}
                          defaultSortOrder={getDefaultSortOrder('source', sorter)}
                          sorter
                      />
                      <Table.Column
                          dataIndex='originalTrackUrl'
                          key='originalTrackUrl'
                          title='Original Track Url'
                          render={(value) => <UrlField target='_blank' value={value}></UrlField>}
                          defaultSortOrder={getDefaultSortOrder('originalTrackUrl', sorter)}
                          sorter
                      />
                      <Table.Column<ISample>
                          title={t('table.actions')}
                          dataIndex='actions'
                          render={(_, record) => (
                              <Space>
                                  <EditButton hideText size='small' recordItemId={record._id} />
                                  {/* <DeleteButton hideText size='small' recordItemId={record._id} /> */}
                              </Space>
                          )}
                      />
                  </Table>
              </Col>
          </Row>
      </List>
  );
};
